// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-RadioButtons-radioButton {\n  margin-left: 5px;\n}\n", "",{"version":3,"sources":["webpack://./modules/ui/components/controls/RadioButtons.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".radioButton {\n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioButton": "x-RadioButtons-radioButton"
};
export default ___CSS_LOADER_EXPORT___;
